module.exports = __webpack_public_path__ + "img/ee2.96b22217.jpg";